module.exports = __webpack_public_path__ + "img/news_title.55ae79a5.png";